// import React, { useState, useEffect, useRef } from "react";
// import { assets } from "../../../assets/assets";
// import "./style/progress.css";
// import { useTabsFilter } from "../../../context/TabsFilterContext";

// function Progress({ isTransparent, onSelectionChange }) {
//   const allItems = ["excellent", "good", "normal", "bad"];

//   const { progressSelection, onFilterChange } = useTabsFilter();
//   const [isDropdownOpen, setIsDropdownOpen] = useState(false);

//   const handleItemClick = (itemName) => {
//     const updated = progressSelection.includes(itemName)
//       ? progressSelection.filter((item) => item !== itemName)
//       : [...progressSelection, itemName];

//     // لو مفيش اختيار → array فاضية
//     const finalSelection = updated.length === 0 ? [] : updated;

//     onFilterChange("construction", finalSelection);
//   };

//   const getButtonText = () => {
//     if (progressSelection.length === allItems.length) return "View All";
//     if (progressSelection.length === 0) return "None";

//     const text = progressSelection.join(", ");

//     return text.length > 30 ? `${text.substring(0, 30)}...` : text;
//   };

//   const isSelected = (itemName) => progressSelection.includes(itemName);

//   const dropdownRef = useRef(null);
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsDropdownOpen(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);

//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   return (
//     <>
//       <div className="dropdown type-unit col-12" ref={dropdownRef}>
//         <p className="p-0 w-100 text-start property-type">Progress</p>

//         <div className="dropdown progress-unit col-12">
//           <button
//             className={`btn btn-view-all dropdown-toggle col-12 ${
//               isTransparent ? "btn-transparent" : "btn-white"
//             }`}
//             type="button"
//             onClick={() => setIsDropdownOpen(!isDropdownOpen)}
//             aria-expanded={isDropdownOpen}
//           >
//             {getButtonText()}
//             <img
//               src={
//                 isTransparent ? assets.arrowDropdown : assets.arrowDropdownWhite
//               }
//               alt="Filter Icon"
//               className="filter-icon arrow-icon"
//             />
//           </button>

//           {isDropdownOpen && (
//             <div
//               className="dropdown-menu col-12 show"
//               onClick={(e) => e.stopPropagation()}
//             >
//               {allItems.map((item, index) => {
//                 const itemClass = item.toLowerCase().replace(/ /g, "-"); 

//                 return (
//                   <p
//                     key={index}
//                     className={`dropdown-item m-0 p-0 ${
//                       isSelected(item) ? `selected-item ${itemClass}` : ""
//                     }`}
//                     onClick={() => handleItemClick(item)}
//                   >
//                     {item}
//                   </p>
//                 );
//               })}
//             </div>
//           )}
//         </div>
//       </div>
//     </>
//   );
// }

// export default Progress;
import React, { useRef } from "react";
import { assets } from "../../../assets/assets";
import "./style/progress.css";
import { useTabsFilter } from "../../../context/TabsFilterContext";

function Progress({ isTransparent, isOpen, toggleOpen }) { 
  const allItems = ["excellent", "good", "normal", "bad"];

  const { progressSelection, onFilterChange } = useTabsFilter();

  const handleItemClick = (itemName) => {
    const updated = progressSelection.includes(itemName)
      ? progressSelection.filter((item) => item !== itemName)
      : [...progressSelection, itemName];

    onFilterChange("construction", updated);
  };

  const getButtonText = () => {
    if (progressSelection.length === allItems.length) return "View All";
    if (progressSelection.length === 0) return "None";

    const text = progressSelection.join(", ");
    return text.length > 30 ? `${text.substring(0, 30)}...` : text;
  };

  const isSelected = (itemName) => progressSelection.includes(itemName);

  const dropdownRef = useRef(null);

  return (
    <div className="dropdown type-unit col-12" ref={dropdownRef}>
      <p className="p-0 w-100 text-start property-type">Progress</p>

      <div className="dropdown progress-unit col-12">
        <button
          className={`btn btn-view-all dropdown-toggle col-12 ${
            isTransparent ? "btn-transparent" : "btn-white"
          }`}
          type="button"
          onClick={toggleOpen} // استخدام الدالة المركزية
          aria-expanded={isOpen}
        >
          {getButtonText()}
          <img
            src={
              isTransparent ? assets.arrowDropdown : assets.arrowDropdownWhite
            }
            alt="Filter Icon"
            className={`filter-icon arrow-icon ${isOpen ? "open" : ""}`} // إضافة كلاس التدوير
          />
        </button>

        {isOpen && (
          <div
            className="dropdown-menu col-12 show"
            onClick={(e) => e.stopPropagation()} // منع الإغلاق عند الضغط داخل القائمة
          >
            {allItems.map((item, index) => {
              const itemClass = item.toLowerCase().replace(/ /g, "-");

              return (
                <p
                  key={index}
                  className={`dropdown-item m-0 p-0 ${
                    isSelected(item) ? `selected-item ${itemClass}` : ""
                  }`}
                  onClick={() => handleItemClick(item)}
                >
                  {item}
                </p>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

export default Progress;